module.exports = __webpack_public_path__ + "static/showprojectselector-9929e6dda58fc5a20b7f78896fbfe50d.png";